import { DefaultSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { appWithTranslation } from 'next-i18next';
import { useFireBaseApp } from '../src/Utils/useFirebase';
// import your default seo configuration
import '@fontsource/montserrat';
import '@fontsource/montserrat/500.css';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import Script from 'next/script';
import platform from 'platform';
import { useEffect, useState } from 'react';
import SEO from '../next-seo.config';
import { images } from '../src/Constants/ImageUrls';
import { BrandName } from '../src/Constants/ProductPage';
import { tuesdaySaleDay } from '../src/Constants/happyTuesdayCounter';
import { fireFbConversionApiEvent } from '../src/Libs/fbpixel';
import { SVGSourceCommon } from '../src/Svg/CommonSvg';
import { deleteCouponCookieIfQueryInCoupon } from '../src/Utils/CartUtils';
import { isIOSAppUser } from '../src/Utils/IosUtils';
import {
  androidGetUserId,
  checkAndroidStopLoader,
} from '../src/Utils/androidUtils';
import {
  getRandomEventId,
  getScreenName,
  isAndroidAppUser,
} from '../src/Utils/helper';
import { cashkaroParamsStorageHandler } from '../src/Utils/productPageUtils';
import useGokwikEvents from '../src/Utils/useGoKwikEvents';
import {
  enableDataDogLogging,
  getGokwikMerchantId,
  getGokwikScript,
  getKwikpassEnvironment,
  getKwikpassScript,
  getPublicUrl,
  getSeoVisibility,
  getShipRocketScript,
} from '../src/appconfig';
import { getEligibilityForAd } from '../src/datafetchers/HomePage';
import { fireEvent } from '../src/Utils/fireEvent';
import DatadogInit from '../datadog-init';

const Loader = dynamic(() => import('../src/components/Loader'), {
  ssr: false,
});

export function reportWebVitals(metric) {
  if (metric.label === 'web-vital') {
    const screenName = getScreenName();
    if (screenName === 'PDP' || screenName === 'Category Page') {
      const urlPath = window.location.pathname;
      const productId = urlPath.split('/').pop().split('-').pop();
      fireEvent({
        category: 'web_vitals',
        screen_name: screenName,
        index: metric.name,
        value: metric.value.toFixed(2),
        product_id: productId,
      });
    }
  }
}

function MyApp({ Component, pageProps }) {
  useFireBaseApp();
  useGokwikEvents();
  const router = useRouter();
  const [showLoader, setShowLoader] = useState(false);
  const webPage = router?.pathname?.includes('store')
    ? 'Mylo Store'
    : `Mylo ${router?.pathname?.split('/')?.[1] || 'WebSite'}`;
  const hideCanonicalTag = router?.asPath?.includes(
    '/parenting/babynames/meaning-of',
  );
  useEffect(() => {
    const initialize = async () => {
      let hideAd = false;
      if (isAndroidAppUser()) {
        const token = androidGetUserId();
        Cookies.set('token', token);
      }
      if (isAndroidAppUser() || isIOSAppUser()) {
        const response = await getEligibilityForAd();
        hideAd = response?.showAd;
      }
      if (!hideAd && !window.location.href.includes('article')) {
        let tag = document.createElement('script');
        tag.src =
          'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5148846221422351';
        document.body.appendChild(tag);
      }
      checkAndroidStopLoader();
      cashkaroParamsStorageHandler();

      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
      });
      const RandomEventId = getRandomEventId();
      router.events.on('routeChangeStart', (url) => {
        setShowLoader(true);
        document.documentElement.classList.add('normal-scroll');
      });
      router.events.on('routeChangeComplete', () => {
        window?.fbq('track', 'PageView', {}, { eventID: RandomEventId });
        fireFbConversionApiEvent('PageView', {}, RandomEventId);
        document.documentElement.classList.remove('normal-scroll');
        if (document.documentElement.classList?.length == 0)
          document.documentElement.removeAttribute('class');

        setShowLoader(false);
      });
      window?.fbq('track', 'PageView', {}, { eventID: RandomEventId });
      fireFbConversionApiEvent('PageView', {}, RandomEventId);

      const currentday = new Date().getDay();
      // check if it is tuesday then add cookie for Tuesday
      if (currentday === tuesdaySaleDay) Cookies.set('currentDay', true, '/');
      else Cookies.remove('currentDay', '/');
      // if (Cookies.get("currentDay")) {
      //     Cookies.remove("currentDay", "/");
      // }
      const userAgent = platform?.ua;
      let pattern = /googlebot/i;
      let timeZone = '';
      if (Intl && Intl.DateTimeFormat)
        timeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
      else timeZone = 'NA';

      fireEvent({
        category: 'platform_details',
        name: platform.name, // 'Safari'
        browser_version: platform.version, // '5.1'
        user_device_model: platform.product, // 'iPad'
        layout: platform.layout, // 'WebKit'
        os: platform.os, // 'iOS 5.0'
        description: platform.description,
        ua1: userAgent?.slice(0, 100),
        ua2: userAgent?.slice(100, 200),
        ua3: userAgent?.slice(200, 300),
        parent: pattern.test(userAgent) ? 'Google Bot' : null,
        timeZone: timeZone,
      });
      // captureUserAgentData(userAgent);
      if (!window.location.pathname.includes('payment')) {
        deleteCouponCookieIfQueryInCoupon();
      }

      if (!sessionStorage.getItem('user_session')) {
        sessionStorage.setItem('user_session', 'true');
        const current_sessions = Cookies.get('user_sessions')
          ? parseInt(Cookies.get('user_sessions'))
          : 0;
        Cookies.set('user_sessions', current_sessions + 1, '/');
      }
    };
    initialize();
  }, []);
  // const pageLanguage = pageProps.language || "en";
  // pageProps["language"] = pageLanguage;
  return (
    <>
      {enableDataDogLogging() && <DatadogInit />}
      {getSeoVisibility() && <DefaultSeo {...SEO}></DefaultSeo>}
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `!function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.defer=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', "1560174350951119");`,
        }}
        id="facebook-script"
      />

      {/* <Script
                strategy="afterInteractive"
                src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5148846221422351"
                crossOrigin="anonymous"
            ></Script> */}

      <Script
        dangerouslySetInnerHTML={{
          __html: `var loadGTM = function () {
                        (function (w, d, s, l, i) {
                            w[l] = w[l] || [];
                            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                            var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s),
                                dl = l != "dataLayer" ? "&l=" + l : "";
                            j.defer = true;
                            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                            f.parentNode.insertBefore(j, f);
                        })(window, document, "script", "dataLayer", "GTM-5BW4G9K");
                    };
                    var loadGtmCaller = function () {
                        var effectiveConnectionType =
                            window.navigator &&
                            window.navigator.connection &&
                            window.navigator.connection.effectiveType
                                ? window.navigator.connection.effectiveType
                                : null;
                        // Setting this value in window for future needs.
                        window.isSlowConnection = /(2g)/.test(effectiveConnectionType);
                        window.isMediumConnection = /(3g)/.test(effectiveConnectionType);
                        var mediumConnection = /(3g)/.test(effectiveConnectionType);
                        // logic to load GTM
                        setTimeout(function () {
                            loadGTM();
                        }, 1000);

                    };
                    if (window.requestIdleCallback) {
                        window.requestIdleCallback(loadGtmCaller);
                    } else {
                        loadGtmCaller();
                    }`,
        }}
        id="gtm-script"
      />

      <Script id="kwikpass-init">
        {`
                    window.merchantInfo = {
                        ...window.merchantInfo,
                        mid: "${getGokwikMerchantId()}",
                        environment: "${getKwikpassEnvironment()}",
                        type: "merchantInfo"
                    };
                `}
      </Script>

      <Script
        dangerouslySetInnerHTML={{
          __html: `(function () {
            window.__KP_LOGIN_SDK_INSTANCE__ = window.__KP_LOGIN_SDK_INSTANCE__ || {};
            window.__KP_LOGIN_SDK_INSTANCE__.logEvents = window.__KP_LOGIN_SDK_INSTANCE__.logEvents || function(event) {
              window.kpqueue = window.kpqueue || [];
              window.kpqueue.push(event);
            };
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.defer = true;
            s.src = "${getKwikpassScript()}";
            s.onload = function() {
              console.log("KwikPass SDK script loaded successfully!");
              window.isKwikPassScriptLoaded = true;
            };
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          })();`,
        }}
        id="kwikpass-script"
      />

      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=no"
        />
        <script defer src={getGokwikScript()}></script>
        {/* <link
                    rel="stylesheet"
                    href="https://checkout-ui.shiprocket.com/assets/styles/shopify.css"
                /> */}
        {/* <script defer src={getShipRocketScript()}></script> */}

        {/* <script
                    defer
                    src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"
                ></script> */}
        <input type="hidden" value="mylofamily.com" id="sellerDomain" />
        <meta
          name="facebook-domain-verification"
          content="q360bp4kv7np10302baao4il6aum21"
        />
        {!getSeoVisibility() ? (
          <>
            <meta name="robots" content="noindex, nofollow" />
            <meta name="googlebot" content="noindex, nofollow" />
          </>
        ) : null}
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
        <link
          rel="icon"
          href={images.headingLogo}
          sizes="any"
          type="image/svg+xml"
        />
        <link rel="manifest" href="/manifest.json" />
        <title>Indian Pregnancy, baby and conception information at Mylo</title>
        <meta httpEquiv="Accept-CH" content="DPR, Viewport-Width, Width" />
        <meta name="theme-color" content="#ef4e5e" />
        <link rel="apple-touch-icon" href={images.headingLogo} />
        <script
          key="organizationLD"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org",
                        "@graph": [{
                            "@type": "Organization",
                            "name": "${BrandName}",
                            "alternateName": "Mylo - Raise Happiness",
                            "url": "https://mylofamily.com",
                            "logo": "${images.headingLogo}"
                        }, {
                          "@type": "WebSite",
                          "@id": "https://mylofamily.com/#website",
                          "url": "https://mylofamily.com/",
                          "name": "Mylo - Raise Happiness,
                          "publisher": {
                            "@id": "https://mylofamily.com/#organization",
                            "name":"${BrandName}"
                          }
                        }, {
                          "@type": "WebPage",
                          "@id": "https://mylofamily.com${
                            router.asPath
                          }#webpage",
                          "url": "https://mylofamily.com${router.asPath}",
                          "inLanguage": "${
                            router.locale || router.defaultLocale
                          }",
                          "name": "${webPage}",
                          "isPartOf": {
                            "@id": "https://mylofamily.com/#website"
                          },
                          "about": {
                            "@id": "https://mylofamily.com/#organization"
                          },
                          "datePublished": "2018-10-03T12:46:10+00:00",
                            "dateModified": "2021-12-16T09:46:06+00:00",
                            "image": {
                            "@type": "ImageObject",
                            "@id": "#primaryimage",
                            "url": "${images.headingLogo}",
                            "width": 800,
                            "height": 800,
                            "caption": ""
                          },
                          "primaryImageOfPage": {
                            "@id": "#primaryimage"
                          }
                        }]}`,
          }}
        ></script>
        {!hideCanonicalTag && (
          <link
            key="canonical"
            rel="canonical"
            href={`${getPublicUrl()}${router?.asPath
              ?.split('?')?.[0]
              ?.toLowerCase()}`}
          />
        )}
      </Head>
      {/* <SVGSource /> */}
      <SVGSourceCommon />
      {showLoader && <Loader />}
      <Component {...pageProps} />
    </>
  );
}

export default appWithTranslation(MyApp);
